import SequenceNumberListResourceModel from '../../generated/types/model/resource/SequenceNumberListResourceModel';

export default class SequenceNumberListResourceViewModel extends SequenceNumberListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
